import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { sharedABQueryKeys } from 'pages/audience/shared/utilities';
import { audienceService } from 'services';
import { IOmitFlag } from 'types/api/audience';
import { IDataContainer, IResult } from 'types/api/common';

export const useFetchOmitFlags = () => {
  return useQuery({
    queryFn: async () => await audienceService.getOmitFlags(),
    queryKey: sharedABQueryKeys.flags,
    select: useCallback(
      (data: IResult<IDataContainer<IOmitFlag[]>> | undefined) => data?.dataContainer?.data ?? [],
      []
    ),
  });
};
